import { writable, readable } from 'svelte/store';

export let selected = writable({
    x: 0,
    y: 0,
    z: 0,
    base: 0,
    pattern: 1,
    color: 15,
    block: 0
});

export let drawingMode = writable({
    block: false,
    base: true,
    pattern: true
});

export let showLayer = writable({
    block: true,
    banner: true
});

export let currentBanner = writable({});
export let currentBase = writable({});
export let currentBlock = writable({});
export let infoText = writable("");  
export let timelapseRunning = writable(false);

export let grid = writable({
    width: 15,
    height: 10,
    banners: new Map()
});

export let shiftDown = writable(false);
export let cDown = writable(false);
export let altDown = writable(false);
export let zDown = writable(false);

export const COLORS = readable([
{name: "White", hex: "#f7fcfb"},
{name: "Orange", hex: "#f77e1c"},
{name: "Magenta", hex: "#c44dbb"},
{name: "Light Blue", hex: "#39b1d8"},
{name: "Yellow", hex: "#fbd63c"},
{name: "Lime", hex: "#7fc51f"},
{name: "Pink", hex: "#f089a8"},
{name: "Gray", hex: "#464e52"},
{name: "Light Gray", hex: "#9b9b95"},
{name: "Cyan", hex: "#169a9a"},
{name: "Purple", hex: "#8731b6"},
{name: "Blue", hex: "#3b44a8"},
{name: "Brown", hex: "#815331"},
{name: "Green", hex: "#5c7b16"},
{name: "Red", hex: "#ae2e25"},
{name: "Black", hex: "#1c1c21"}
]);

export const BANNER_NAMES = readable([
{name: 'Base', ingame: 'Fully color Field', code:"b"},
{name: 'Left of Diagonal', ingame: 'Per bend sinister', code:"ld"},
{name: 'Right of upside-down Diagonal', ingame: 'Per bend', code:"rud"},
{name: 'Left of upside-down Diagonal', ingame: 'Per bend inverted', code:"lud"},
{name: 'Right of Diagonal', ingame: 'Per bend sinister inverted', code:"rd"},
{name: 'Horizontal Half (bottom)', ingame: 'Per fess inverted', code:"hhb"},
{name: 'Bottom Stripe', ingame: 'Base', code:"bs"},
{name: 'Middle Stripe (Horizontal)', ingame: 'Fess', code:"ms"},
{name: 'Horizontal Half (top)', ingame: 'Per fess', code:"hh"},
{name: 'Vertical Half (left)', ingame: 'Per pale', code:"vh"},
{name: 'Left Stripe', ingame: 'Pale dexter', code:"ls"},
{name: 'Center Stripe (Vertical)', ingame: 'Pale', code:"cs"},
{name: 'Vertical Half (right)', ingame: 'Per pale inverted', code:"vhr"},
{name: 'Right Stripe', ingame: 'Pale sinister', code:"rs"},
{name: 'Bottom Left Corner', ingame: 'Base dexter canton', code:"bl"},
{name: 'Bottom Right Corner', ingame: 'Base sinister canton', code:"br"},
{name: 'Square Cross', ingame: 'Cross', code:"sc"},
{name: 'Diagonal Cross', ingame: 'Saltire', code:"cr"},
{name: 'Down Left Stripe', ingame: 'Bend sinister', code:"dls"},
{name: 'Down Right Stripe', ingame: 'Bend', code:"drs"},
{name: 'Curly Border', ingame: 'Bordure indented', code:"cbo"},
{name: 'Middle Circle', ingame: 'Roundel', code:"mc"},
{name: 'Middle Rhombus', ingame: 'Lozenge', code:"mr"},
{name: 'Top Triangle', ingame: 'Inverted chevron', code:"tt"},
{name: 'Bottom Triangle', ingame: 'Chevron', code:"bt"},
{name: 'Bottom Triangle Sawtooth', ingame: 'Base indented', code:"bts"},
{name: 'Border', ingame: 'Bordure', code:"bo"},
{name: 'Brick', ingame: 'Field masoned', code:"bri"},
{name: 'Small (Vertical) Stripes', ingame: 'Paly', code:"ss"},
{name: 'Gradient upside-down', ingame: 'Base gradient', code:"gru"},
{name: 'Gradient', ingame: 'Gradient', code:"gra"},
{name: 'Mojang', ingame: 'Thing', code:"moj"},
{name: 'Piglin', ingame: 'Snout', code:"pig"},
{name: 'Skull', ingame: 'Skull charge', code:"sku"},
{name: 'Creeper', ingame: 'Creeper charge', code:"cre"},
{name: 'Flower', ingame: 'Flower charge', code:"flo"},
{name: 'Globe', ingame: 'Globe', code:"glb"},
{name: 'Top Triangle Sawtooth', ingame: 'Chief indented', code:"tts"},
{name: 'Top Stripe', ingame: 'Chief', code:"ts"},
{name: 'Top Left Corner', ingame: 'Chief dexter canton', code:"tl"},
{name: 'Top Right Corner', ingame: 'Chief sinister canton', code:"tr"},    
]);
